import React, { useState } from "react";

function AssessmentDateStatusModal({ title, onClose, modalData }) {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content shadow rounded-4">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body fs-9">
              {/* <div className="text-center pt-2 pb-4">
                <i className="fa fa-info-circle fs-2 text-primary"></i>
              </div> */}
              {/* <div className="mb-2 d-flex justify-content-between">
                <strong>Pupil Name:</strong>
                <div>{modalData.studentName}</div>
              </div> */}
              <div className="mb-2 d-flex justify-content-between">
                <strong>Year Group:</strong>
                <div>{modalData.className}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Teacher(s):</strong>
                <div>{modalData.teachersName}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Assessment Date:</strong>
                <div>{modalData.scheduleDate?.split("T")[0]}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Assessment Slot:</strong>
                <div>{modalData.slotName}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Remarks:</strong>
                <div>{modalData.remarks}</div>
              </div>
              <div className="text-center mt-4">
                <button
                  className="btn btn-primary btn-sm w-100 rounded-pill"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default AssessmentDateStatusModal;
